import { render, staticRenderFns } from "./syncOrder.vue?vue&type=template&id=5689dde9&scoped=true"
import script from "./syncOrder.vue?vue&type=script&lang=js"
export * from "./syncOrder.vue?vue&type=script&lang=js"
import style0 from "./syncOrder.vue?vue&type=style&index=0&id=5689dde9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5689dde9",
  null
  
)

export default component.exports